import { DialogComponent, DialogOpenEvent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * Cart Drawer Component
 */
class CartDrawerComponent extends DialogComponent {

  #summaryThreshold = 0.5;

  // ⭐ FREE SHIPPING LIMIT
  #freeShippingThreshold = 100;

#handleCartUpdate = () => {

  setTimeout(() => {

    const { dialog } = this.refs;
    if (!dialog) return;

    this.#renderFreeShipping();
    this.#loadUpsells();

  }, 300);

};
  
connectedCallback() {
  super.connectedCallback();


  document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  document.addEventListener(CartAddEvent.eventName, this.#handleCartUpdate);

  this.addEventListener(DialogOpenEvent.eventName, this.#updateStickyState);
  this.addEventListener('click', this.#handleUpsellAdd);

  // ⭐ Rebuild dynamic cart features after cart refresh
  document.addEventListener(CartAddEvent.eventName, () => {
    setTimeout(() => {
      this.#renderFreeShipping();
      this.#loadUpsells();
    }, 150);
  });
}
  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.removeEventListener(DialogOpenEvent.eventName, this.#updateStickyState);

    this.removeEventListener('click', this.#handleUpsellAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
      this.#renderFreeShipping();
    }
  };

  open() {
    this.showDialog();

    this.#loadUpsells();
    this.#renderFreeShipping();

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent =
        document.querySelector('shopify-payment-terms')?.shadowRoot;

      const cta =
        installmentsContent?.querySelector('#shopify-installments-cta');

      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }

  /**
   * FREE SHIPPING PROGRESS BAR
   */
 #renderFreeShipping = async () => {

  const { dialog } = this.refs;
  if (!dialog) return;

  let container = dialog.querySelector('[data-free-shipping]');

  if (!container) {

    container = document.createElement('div');
    container.setAttribute('data-free-shipping', '');
    container.className = 'cart-free-shipping-wrapper';

    const content = dialog.querySelector('.cart-drawer__content');
    if (!content) return;

    content.prepend(container);

    // Create static structure once
    container.innerHTML = `
      <div class="free-shipping">

        <div class="free-shipping__header">
          <span class="free-shipping__icon">🚚</span>
          <span class="free-shipping__text"></span>
        </div>

        <div class="free-shipping__bar">
          <div class="free-shipping__progress"></div>
        </div>

      </div>
    `;
  }

  const text = container.querySelector('.free-shipping__text');
  const progressBar = container.querySelector('.free-shipping__progress');

try {

  const cart = await fetch('/cart.js').then(r => r.json());

  // ❗ If cart empty → hide free shipping
  if (!cart.item_count) {
    container.style.display = 'none';
    return;
  }

  container.style.display = '';

  const cartTotal = cart.total_price / 100;
  const remaining = this.#freeShippingThreshold - cartTotal;

  const progress = Math.min(
    (cartTotal / this.#freeShippingThreshold) * 100,
    100
  );

  progressBar.style.width = `${progress}%`;

    if (remaining <= 0) {

      text.innerHTML = `You unlocked <strong>FREE SHIPPING!</strong>`;
      text.classList.add('success');
      progressBar.classList.add('unlocked');

    } else {

      text.innerHTML = `
        You're <strong>$${remaining.toFixed(2)}</strong> away from
        <strong>FREE SHIPPING</strong>
      `;

      text.classList.remove('success');
      progressBar.classList.remove('unlocked');

    }

  } catch (error) {
    console.error('Free shipping error', error);
  }
};

  /**
   * Load upsell products
   */
  #loadUpsells = async () => {

    const { dialog } = this.refs;
    if (!dialog) return;

    const upsellContainer = dialog.querySelector('[data-upsells]');
    if (!upsellContainer) return;

    const firstCartItem = dialog.querySelector('[data-product-id]');
    const productId = firstCartItem?.dataset.productId;

    if (!productId) {
      upsellContainer.innerHTML = '';
      return;
    }

    try {

      const response = await fetch(
        `/recommendations/products.json?product_id=${productId}&limit=4`
      );

      const data = await response.json();

      if (!data.products.length) {
        upsellContainer.innerHTML = '';
        return;
      }

      upsellContainer.innerHTML = `
        <div class="cart-upsells">

          <h3 class="cart-upsells__title">You may also like</h3>

          <div class="cart-upsells__list">

            ${data.products
              .map(
                (product) => `

              <div class="cart-upsell">

                <a href="${product.url}" class="cart-upsell__image">
                  <img src="${product.featured_image}" alt="${product.title}">
                </a>

                <a href="${product.url}" class="cart-upsell__title">
                  ${product.title}
                </a>

                <div class="cart-upsell__price">
                  $${(product.price / 100).toFixed(2)}
                </div>

                <button
                  class="cart-upsell__add"
                  data-variant-id="${product.variants[0].id}">
                  Add
                </button>

              </div>
            `
              )
              .join('')}

          </div>

        </div>
      `;
    } catch (error) {
      console.error('Upsell load error', error);
    }
  };

  /**
   * Upsell add handler
   */
  #handleUpsellAdd = async (event) => {

    const button = event.target.closest('.cart-upsell__add');
    if (!button) return;

    const variantId = button.dataset.variantId;

    button.disabled = true;
    button.textContent = 'Adding...';

    try {

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },

        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      });

      const cart = await fetch('/cart.js').then(res => res.json());

document.dispatchEvent(
  new CustomEvent(CartAddEvent.eventName, {
    detail: { data: cart }
  })
);

// Wait for cart drawer to re-render
setTimeout(() => {
  this.#renderFreeShipping();
  this.#loadUpsells();
}, 200);

button.textContent = 'Added';

      // ⭐ UPDATE FREE SHIPPING BAR
      this.#renderFreeShipping();

    } catch (error) {

      console.error('Upsell add error', error);

      button.disabled = false;
      button.textContent = 'Add';
    }
  };

  #updateStickyState() {

    const { dialog } = this.refs;
    if (!dialog) return;

    const content = dialog.querySelector('.cart-drawer__content');
    const summary = dialog.querySelector('.cart-drawer__summary');

    if (!content || !summary) {
      dialog.setAttribute('cart-summary-sticky', 'false');
      return;
    }

    const drawerHeight = dialog.getBoundingClientRect().height;
    const summaryHeight = summary.getBoundingClientRect().height;
    const ratio = summaryHeight / drawerHeight;

    dialog.setAttribute(
      'cart-summary-sticky',
      ratio > this.#summaryThreshold ? 'false' : 'true'
    );
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}